import {default as React, useState} from "react";
import {CardObject} from "../../types.d";
import {Modal, ModalBody, ModalHeader} from 'reactstrap';
import {beautifyFalseAnswers, beautifyInfinitives} from "../../utils/falseAnswers";
import {Form} from "@intelingu/core/components/form/Form";

export const ExerciseTopic = ({ card }: { card: CardObject }) => {
    const [topicModalVisible, setTopicModalVisible] = useState(false);
    const [completeModalVisible, setCompleteModalVisible] = useState<number>(null);

    const currentRelatedExp = () => card.explanation.explanationExercises[completeModalVisible];

    console.log(card.explanation.explanationExercises);

    return <div className="card">
        <div className="card-body">
            <h4 className="card-title">recent Explanation Card</h4>
            <p dangerouslySetInnerHTML={{
                __html: card.explanation.explanationRules
            }} />

            <a href="" onClick={e => {
                e.preventDefault();
                setTopicModalVisible(true);
            }}>
                See complete Grammar Topic ({ card.topic.title })
            </a>

            <h4 className="card-title mt-4">related Exercise Cards</h4>
            { card.explanation.explanationExercises.filter(item => item.id !== card.id && item.explanationRules).map((item, index) => (
                <p key={item.id}>
                    <span dangerouslySetInnerHTML={{
                        __html: item.explanationRules
                    }} />
                    <a href={''} onClick={e => {
                        e.preventDefault();
                        setCompleteModalVisible(card.explanation.explanationExercises.findIndex(itm => itm.id === item.id));
                    }}> (complete content)</a>
                </p>
            )) }
        </div>

        <Modal isOpen={topicModalVisible}
               className={'large-modal'}
               toggle={() => setTopicModalVisible(!topicModalVisible)}>
            <ModalHeader toggle={() => setTopicModalVisible(false)}>Topic Block Overview: { card.topic.title }</ModalHeader>
            <ModalBody>
                <h4>Description</h4>

                <div dangerouslySetInnerHTML={{
                    __html: card.topic.description
                }} />
            </ModalBody>
        </Modal>

        <Modal isOpen={completeModalVisible !== null}
               className={'large-modal'}
               toggle={() => setCompleteModalVisible(null)}>
            <ModalHeader toggle={() => setCompleteModalVisible(null)}>{ card.topic.title } { currentRelatedExp()?.postTitle }</ModalHeader>
            <ModalBody>
                <h4>Description</h4>

                { completeModalVisible !== null && (
                    <>
                        <div className="col-12 row mt-5">
                            <div className="col-3"><label><strong>Exercise</strong>:</label></div>
                            <div className="col-9"><span dangerouslySetInnerHTML={{ __html: currentRelatedExp().explanationRules }} /></div>
                        </div>
                        <div className="col-12 row">
                            <div className="col-3"><label><strong>False answers</strong>:</label></div>
                            <div className="col-9"><span>{ beautifyFalseAnswers(currentRelatedExp().falseAnswers) }</span></div>
                        </div>
                        <div className="col-12 row">
                            <div className="col-3"><label><strong>Translation</strong>:</label></div>
                            <div className="col-9"><span dangerouslySetInnerHTML={{ __html: currentRelatedExp().exerciseTranslation }} /></div>
                        </div>
                        <div className="col-12 row">
                            <div className="col-3"><label><strong>Infinitives Only</strong>:</label></div>
                            <div className="col-9"><span>{ beautifyInfinitives(currentRelatedExp().infinitivesOnly) }</span></div>
                        </div>
                    </>
                ) }
            </ModalBody>
        </Modal>
    </div>
};
